import { useTheme, getColorVisionEventAttrs, getColorVisionStylesForActiveIndex } from '@shopify/polaris-viz-core';
import { LEGEND_ITEM_LEFT_PADDING, LEGEND_ITEM_RIGHT_PADDING, LEGEND_ITEM_GAP } from '../../constants.js';
import { PREVIEW_ICON_SIZE } from '../../../../constants.js';
import style from './LegendItem.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SeriesIcon } from '../../../shared/SeriesIcon/SeriesIcon.js';

function LegendItem({
  activeIndex = -1,
  color,
  colorVisionType,
  index,
  isComparison,
  name,
  shape,
  theme,
  value
}) {
  const selectedTheme = useTheme(theme);
  const colorBlindAttrs = colorVisionType == null ? {} : getColorVisionEventAttrs({
    type: colorVisionType,
    index
  });
  return /*#__PURE__*/jsxs("button", { ...colorBlindAttrs,
    style: {
      background: selectedTheme.legend.backgroundColor,
      ...getColorVisionStylesForActiveIndex({
        activeIndex,
        index
      }),
      paddingLeft: LEGEND_ITEM_LEFT_PADDING,
      paddingRight: LEGEND_ITEM_RIGHT_PADDING,
      gap: LEGEND_ITEM_GAP
    },
    className: style.Legend,
    children: [/*#__PURE__*/jsx("span", {
      style: {
        height: PREVIEW_ICON_SIZE,
        width: PREVIEW_ICON_SIZE
      },
      className: style.IconContainer,
      children: /*#__PURE__*/jsx(SeriesIcon, {
        shape: shape,
        color: color,
        isComparison: isComparison
      })
    }), /*#__PURE__*/jsxs("span", {
      className: style.TextContainer,
      children: [/*#__PURE__*/jsx("span", {
        style: {
          color: selectedTheme.legend.labelColor
        },
        children: name
      }), value == null ? null : /*#__PURE__*/jsx("span", {
        style: {
          color: selectedTheme.legend.valueColor
        },
        children: value
      })]
    })]
  });
}

export { LegendItem };
